
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoCampaignDialog extends Serenity.EntityDialog<PsPromoCampaignRow, any> {
        protected getFormKey() { return PsPromoCampaignForm.formKey; }
        protected getIdProperty() { return PsPromoCampaignRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoCampaignRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoCampaignRow.nameProperty; }
        protected getService() { return PsPromoCampaignService.baseUrl; }
        protected getDeletePermission() { return PsPromoCampaignRow.deletePermission; }
        protected getInsertPermission() { return PsPromoCampaignRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoCampaignRow.updatePermission; }

        protected form = new PsPromoCampaignForm(this.idPrefix);

    }
}